import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import { FacilityClass } from "@/js/value-objects/facility-class";
import { EvaFacilityStatusTranslator } from "@/js/translators/evaFacilityStatusTranslator";
import { FacilityTranslator } from "@/js/translators/facilityTranslator";
const evaFacilityStatusRepository = RepositoryFactory.get("evaFacilityStatus");
const facilityEvaInfoRepository = RepositoryFactory.get("facilityEvaInfo");

const state = () => ({
  data: {},
  facilityStatuses: {}
});
const getters = {};
const mutations = {
  setEvaFacilityStatus(state, payload) {
    state.data = payload;
  }
};
const actions = {
  async loadEvaFacilityStatus(context, payload) {
    // 原子力災害施設状況を取得する
    const list = await evaFacilityStatusRepository.list(
      payload.screenId,
      payload.municipality,
      payload.disasterNo
    );
    if (list.status < 300) {
      /* 成功時 */

      // 避難者入所情報を取得
      const facilityEvaInfo = await loadFacilityEvaInfo(payload);

      // 原子力災害施設状況の各データに対して以下を実行
      list.data.results.forEach(facility => {
        // 対象にしている原子力災害施設状況のデータと同じ施設IDを持つ
        // 避難者入所情報のデータ内の{enter_count, exit_count}を取得する
        const qrInfo = EvaFacilityStatusTranslator.qrInfo(
          facilityEvaInfo,
          facility.fa_id
        );

        // 対象にしている原子力災害施設状況のprevent_faclsの値をfacility_classの値にする
        const facilityClass = facility.prevent_facls;

        // facility_classの値を元に、FacilityClassをインスタンス化する
        const facilityClassVo = FacilityClass.factory(facilityClass);

        // 原子力災害施設状況のデータに情報を追加する
        Object.assign(facility, {
          facility_class: facilityClass,
          // TODO: 使用用途調査
          read_only_row: true,
          // TODO: 使用用途調査
          current_seating_capacity: EvaFacilityStatusTranslator.currentSeatingCapacity(
            facility
          ),
          // TODO: 使用用途調査
          qr_enter_num: qrInfo.enterCount,
          // TODO: 使用用途調査
          qr_exit_num: qrInfo.exitCount
        });

        if (facilityClassVo.isShelterOrMeeting()) {
          /* 避難所であれば */

          // 原子力災害施設状況のeva_area_infoを元に
          // {eva_area_info, eva_municip_code_list, eva_area_code_list}情報を
          // 原子力災害施設状況のデータに追加（更新）する
          // TODO: eva_area_infoを上書きしている理由調査
          Object.assign(
            facility,
            FacilityTranslator.toEveMunicipalitiesAndEveAreasFromEvaAreaInfo(
              facility.eva_area_info
            )
          );
        }
      });

      // 上記までに作成した情報でthis.dataを更新
      context.commit("setEvaFacilityStatus", list.data);
    }
  }
};

const loadFacilityEvaInfo = async payload => {
  const list = await facilityEvaInfoRepository.list(
    payload.screenId,
    payload.disasterNo
  );
  if (list.status < 300) {
    return list.data.results;
  }
  return null;
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
